export class KeyAccountManager {
    public id: number | null;
    public code: string;
    public name: string;
    public tms_road_name: string;
    public job_title: string;
    public commission: number | null;
    public phone_number: string;
    public email: string;
    public blocked: number | null;
    public privacy_blocked: number | null;

    constructor(data: KeyAccountManagerData | void) {
        if (data === undefined) {
            this.id = null;
            this.code = "";
            this.name = "";
            this.tms_road_name = "";
            this.job_title = "";
            this.commission = null;
            this.phone_number = "";
            this.email = "";
            this.blocked = null;
            this.privacy_blocked = null;

        } else {
            this.id = data.id;
            this.code = data.code;
            this.name = data.name;
            this.tms_road_name = data.tms_road_name;
            this.job_title = data.job_title;
            this.commission = data.commission;
            this.phone_number = data.phone_number;
            this.email = data.email;
            this.blocked = data.blocked;
            this.privacy_blocked = data.privacy_blocked;
        }
    }
}

export type KeyAccountManagerData = {
    id: number | null;
    code: string;
    name: string;
    tms_road_name: string;
    job_title: string;
    commission: number | null;
    phone_number: string;
    email: string;
    blocked: number | null;
    privacy_blocked: number | null;


}